import { PlatformFeatureType } from "@/types/graphql/admin.generated";

// Фичефлаг платформы (спека live-reactions-and-polls, «Фичефлаг»):
// включается только здесь, партнёр видит его, но не меняет.
export const PLATFORM_FEATURE_OPTIONS: {
  label: string;
  value: PlatformFeatureType;
}[] = [
  {
    label: "Живые реакции на эфирах",
    value: PlatformFeatureType.LiveReactionsType,
  },
  { label: "Опросы в плеере", value: PlatformFeatureType.PlayerPollsType },
  {
    label: "Рассылки и цепочки писем",
    value: PlatformFeatureType.MarketingEmailsType,
  },
];

const KNOWN_FEATURES = new Set<string>(Object.values(PlatformFeatureType));

export function toPlatformFeaturesInput(
  features: readonly string[] | null | undefined
): PlatformFeatureType[] {
  return [
    ...new Set((features ?? []).filter((value) => KNOWN_FEATURES.has(value))),
  ] as PlatformFeatureType[];
}
